import script from "./PointageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PointageTable.vue?vue&type=script&setup=true&lang=js"

import "./PointageTable.vue?vue&type=style&index=0&id=21bfbe38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bfbe38"]])

export default __exports__